// Store only a public boutique code. Authorization always comes from fresh context.
export function teamBoutiquePreferenceKey(user, origin = window.location.origin) {
  const identity = user?.user_id || user?.id || user?.sub;
  if (!identity) return null;
  const organization = user?.organization_id || user?.org_id || user?.tenant_id || 'single-organization';
  return `toto-team-boutique:${JSON.stringify([origin, organization, identity])}`;
}
export function rememberedTeamBoutique(key, authorized) {
  if (!key) return null;
  try {
    const code = localStorage.getItem(key);
    if (authorized.includes(code)) return code;
    if (code) localStorage.removeItem(key);
  } catch { /* Local storage is optional. */ }
  return null;
}
export function rememberTeamBoutique(key, code) {
  if (!key) return;
  try { localStorage.setItem(key, code); } catch { /* Context still works without storage. */ }
}
